import { useTranslation } from 'react-i18next';
import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';
import type { LegalBlock } from './legalBlocks';

export default function LegalPage({ blocks }: { blocks: LegalBlock[] }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-bg">
        <div className="mx-auto max-w-3xl px-5 py-14">
          {blocks.map((b) => {
            const text = t(b.k);
            if (b.kind === 'h1') {
              return <h1 key={b.k} className="text-[28px] font-bold tracking-tight">{text}</h1>;
            }
            if (b.kind === 'meta') {
              return <p key={b.k} className="mt-2 text-[13px] text-muted">{text}</p>;
            }
            if (b.kind === 'h2') {
              return <h2 key={b.k} className="text-[18px] font-semibold text-ink mt-8 mb-1">{text}</h2>;
            }
            if (b.kind === 'h3') {
              return <h3 key={b.k} className="text-[15px] font-semibold text-ink mt-5 mb-1">{text}</h3>;
            }
            return (
              <div key={b.k} className="mt-2 space-y-2 text-[15px] leading-relaxed text-ink-soft">
                {text.split('\n').map((line, i) =>
                  line.trim() ? <p key={i}>{line}</p> : null
                )}
              </div>
            );
          })}
        </div>
      </main>
      <Footer />
    </div>
  );
}
